module.exports = __webpack_public_path__ + "static/media/squirrel.a15a3789.svg";